<template>
    <div class="error-page display--flex color--green">
        <h1 class="error-page__title">Oops</h1>
        <icon-not-found class="error-page__svg" />
        <h2 class="error-page__subtitle capitalize">{{ $t('error.notFound') }}</h2>
        <base-button
            type="button"
            class="error-page__button background--green color--white"
            v-html="$t('global.back')"
            @click="$router.go( -1 )"
        />
    </div>
</template>

<script>
export default {
    components: {
        IconNotFound: () => import( /* webpackChunkName: 'IconNotFound' */ '@/components/bundles/layout/images/icons/IconNotFound' ),
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' )
    }
};
</script>

<style lang="scss">
    .error-page {
        flex-direction: column;
        @include position-grid( center, center );
        min-height: calc( 100vh - 100px );
        &__title {
            @include typography-specs( 80px, 106px, 800 );
        }
        &__svg {
            margin: 50px 0 75px;
            .global {
                isolation: isolate;
            }
            .path {
                &--back {
                    isolation: isolate;
                    fill: $color-green-light;
                    mix-blend-mode: multiply;
                }
                &--front {
                    fill: $color-white;
                    opacity: .966;
                }
            }
        }
        &__subtitle {
            @include typography-specs( 40px, 53px, 800 );
        }
        &__button {
            max-width: 357px;
            margin-top: 30px;
        }
    }
</style>